var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdgeScalloped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.7 100.8",
    style: {
      enableBackground: "new 0 0 100.7 100.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#505050;strokeWidth:3;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.43023,89.64731c-2.8,0-5.4-1.3-7.1-3.6c-4.3,2.4-9.8,0.9-12.3-3.4c-0.4-0.7-0.7-1.4-0.9-2.1 c-2.8,0.4-5.6-0.6-7.5-2.6c-1.9-1.9-2.8-4.6-2.4-7.3c-2.7-0.7-4.9-2.7-5.9-5.2c-1.1-2.6-0.9-5.5,0.5-7.9c-2.2-1.7-3.5-4.3-3.6-7.1 c0-2.8,1.3-5.4,3.6-7.1c-1.4-2.5-1.5-5.4-0.4-8c1-2.5,3.2-4.4,5.8-5.2c-0.6-4.9,3-9.4,7.9-9.9c0.7-0.1,1.4-0.1,2,0 c0.7-2.8,2.7-5,5.3-6.1c2.6-1,5.4-0.8,7.8,0.6c1.7-2.2,4.3-3.5,7.1-3.6l0,0c2.8,0,5.4,1.3,7.1,3.6c2.4-1.4,5.3-1.6,7.90001-0.5 c2.6,1.1,4.6,3.3,5.3,6c2.8-0.3,5.6,0.6,7.6,2.6c1.8,1.9,2.7,4.6,2.4,7.3c4.8,1.3,7.6,6.3,6.3,11.1c-0.2,0.7-0.5,1.5-0.9,2.1 c3.9,3.1,4.6,8.8,1.5,12.7c-0.4,0.6-0.9,1-1.5,1.5c2.5,4.3,1,9.8-3.3,12.3c-0.7,0.4-1.3,0.7-2.1,0.9c0.6,4.9-2.9,9.5-7.8,10.1 c-0.7,0.1-1.5,0.1-2.2,0c-1.4,4.8-6.3,7.6-11.1,6.2c-0.7-0.2-1.4-0.5-2-0.9C55.83023,88.44731,53.23024,89.74731,50.43023,89.64731 L50.43023,89.64731z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdgeScalloped);
export default __webpack_public_path__ + "static/media/icon-edge-scalloped.60a75df2eebd47947495aa91fec33e07.svg";
export { ForwardRef as ReactComponent };